var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trck-content water-track-left"},[_c('WaterIncidentInfo',{staticClass:"info-box",attrs:{"data-ready":_vm.countsReady,"incidents":_vm.typeCounts,"show-chart":false,"full-width":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }